import { useTranslation } from 'react-i18next'

import { Tree } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { FormatNumber, Text } from '@reveni-io/reveni-ui'

import NoResultsFound from '@/common/components/NoResultsFound/NoResultsFound'
import StatsInfo from '@/common/components/StatsInfo/StatsInfo'

import DeliveryMethod from './DeliveryMethod/DeliveryMethod'
import DeliveryMethodsListSkeleton from './DeliveryMethodsListSkeleton/DeliveryMethodsListSkeleton'
import TableHeader from './TableHeader/TableHeader'
import { getDeliveryMethods } from './helpers'
import * as Styles from './styles'

const DeliveryMethodsList = ({
  loading,
  deliveryMethods,
  logisticsPreferences,
  carbonOffset,
  regions,
  isUnifiedDashboard,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (loading) return <DeliveryMethodsListSkeleton />
  if (!deliveryMethods?.length) return <NoResultsFound />

  return (
    <Styles.MainContainer>
      <div>
        <TableHeader />
        <Styles.TableContainer>
          {getDeliveryMethods(deliveryMethods, logisticsPreferences?.delivery_methods, regions)?.map(
            (deliveryMethod, index) => (
              <DeliveryMethod
                key={index}
                deliveryMethod={{ ...deliveryMethod, index: index + 1 }}
                regions={regions}
                isUnifiedDashboard={isUnifiedDashboard}
              />
            )
          )}
        </Styles.TableContainer>
      </div>
      {Number(carbonOffset) > 0 && (
        <StatsInfo
          backgroundColor={theme.colors.success.surface}
          icon={<Tree size={20} color={theme.colors.text.default} />}
          backgroundIcon={theme.colors.background.decorative}
          label={
            <Text type="allCapsL" customStyles={{ textTransform: 'uppercase' }}>
              {t('Huella de carbono')}
            </Text>
          }
          info={
            <Styles.CarbonOffsetContainer>
              <Text type="titleL" color={theme.colors.success.hover}>
                {Number(carbonOffset) >= 0 ? <FormatNumber style="decimal">{Number(carbonOffset)}</FormatNumber> : '-'}
              </Text>
              <Text type="bodyMRegular" color={theme.colors.success.hover}>
                {t('de tus clientes han decidido donar para plantar un árbol')}
              </Text>
            </Styles.CarbonOffsetContainer>
          }
        />
      )}
    </Styles.MainContainer>
  )
}

export default DeliveryMethodsList
